import { Component, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { CheckoutExtensionUI } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';
import { type IDynamicFieldsOptions } from '@pdqdev/pdq-shared/dist/interfaces/IDynamicFields';
import { capitalize } from '@utils/string-utils';
import { BehaviorSubject } from 'rxjs';
import { BadgeFormGroup } from '../../models';
import { BADGE_ICON_OPTIONS } from '../../../urgency-boost/model';

@Component({
  selector: 'product-upgrade-badge-form',
  templateUrl: './product-upgrade-badge-form.component.html',
  styleUrls: ['./product-upgrade-badge-form.component.scss'],
  standalone: false,
})
export class ProductUpgradeBadgeFormComponent {
  @Input() formGroup!: FormGroup<BadgeFormGroup>;
  @Input() dynamicFieldsAutocompleteOptions$!: BehaviorSubject<IDynamicFieldsOptions[]>;
  @Input() title = 'Badge';

  readonly cornerRadiusOptions = Object.values(CheckoutExtensionUI.CornerRadius).map((value) => ({
    label: capitalize(value),
    value,
  }));

  readonly presetIconKeys = BADGE_ICON_OPTIONS.map((o) => o.key);
  readonly presetIconLabels = BADGE_ICON_OPTIONS.map((o) => o.label);

  readonly badgeDisabledFormats = ['italic', 'bold', 'underline', 'strike', 'align', 'list', 'header'];

  readonly richTextConfig = {
    triggerChar: '{',
    filterByKey: 'searchTerm',
    removeTriggerCharOnSelect: true,
    descriptionKey: 'description',
    variant: 'categorizedOptions',
  };

  get isEnabled(): boolean {
    return this.formGroup.controls.enabled.value;
  }

  get textControl(): FormControl<string> {
    return this.formGroup.get('text') as FormControl<string>;
  }

  get backgroundColorControl(): FormControl<string> {
    return this.formGroup.get('backgroundColor') as FormControl<string>;
  }

  get textColorControl(): FormControl<string> {
    return this.formGroup.get('textColor') as FormControl<string>;
  }

  get iconControl(): FormControl<string | null> {
    return this.formGroup.get('icon') as FormControl<string | null>;
  }

  get iconValue(): string {
    return this.iconControl.value ?? '';
  }

  onIconUrlChange(value: string | File): void {
    // The badge stores a preset icon key or null (no icon); the picker only
    // emits preset keys or '' since custom uploads are disabled here.
    this.iconControl.setValue(typeof value === 'string' && value ? value : null);
    this.iconControl.markAsDirty();
  }
}
